import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from '../../app.settings';
import { CardDetailsModalComponent } from '../card-details-modal/card-details-modal.component';
import { RegisterUserModalComponent } from '../register-user-modal/register-user-modal.component';
import { BaseComponent } from '../../../globals/classes/base.component';

@Component({
	selector: 'ibank-credentials-modal',
	template: require('./ibank-credentials-modal.component.html'),
})
export class IBankCredentialsModalComponent extends BaseComponent {
	private isNewLoginFlow: boolean = AppSettings.isHybridLoginEnabled;
	public dynatraceForExistingOnBoarding: boolean = AppSettings.dynatraceForExistingOnBoarding;
	public isRebrading = AppSettings.isRebrading;
	constructor(private activeModal: NgbActiveModal, private modalService: NgbModal) {
		super();
	}

	closeModal(): void {
		this.activeModal.close();
	}

	toggleRegister() {
		this.activeModal.close();
		this.modalService.open(RegisterUserModalComponent, {
			windowClass: 'modal-small',
		});
	}

	toggleCardDetails(): void {
		if (this.dynatraceForExistingOnBoarding) this._setInitRegistDynatraceEvent();
		this.activeModal.close();
		this.modalService.open(CardDetailsModalComponent, {
			windowClass: 'modal-small',
		});
	}

	public isFirstStep(): boolean {
		if (this.isNewLoginFlow) return true;
		else return false;
	}

	private _setInitRegistDynatraceEvent() {
		this.setDynatraceEvent('ECO_Start_Registration');
	}
}
